// extracted by mini-css-extract-plugin
module.exports = {"container":"LocationSeoLinks_container__gin_f","tags":"LocationSeoLinks_tags__qfgYa"};